export default "__VITE_ASSET__98b05686__"